module.exports = __webpack_public_path__ + "static/valerie-chavot-f91464e8e58e16066fb1e3e53db3e16a.jpg";